import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import {
  Firestore,
  collection,
  getDocs,
  query,
  where,
} from '@angular/fire/firestore';
import { MatDialog } from '@angular/material/dialog';
import { Auth } from '@angular/fire/auth';
import { ServiceOfferDialogComponent } from '../service-offer-dialog/service-offer-dialog.component';
import { UxserviceService } from 'src/app/shared/services/uxservice.service';
import { BookingLockService } from 'src/app/shared/services/booking-lock.service';
import { DemoVendorService } from 'src/app/shared/services/demo-vendor.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-category-detail',
  templateUrl: './category-detail.component.html',
  styleUrls: ['./category-detail.component.scss'],
})
export class CategoryDetailComponent implements OnInit {
  @ViewChild('scrollArea') scrollArea!: ElementRef;
  @ViewChild('scrollBarWrapper') scrollBarWrapper!: ElementRef;
  @ViewChild('scrollThumb') scrollThumb!: ElementRef;

  yearFromInput: number | null = null;
  yearToInput: number | null = null;
  allYearsForDropdown: number[] = [];
  validYearRange: number[] = [];
  dragging = false;
  startX = 0;
  startScrollLeft = 0;
  fromOpen = false;
  toOpen = false;
  searchFrom = '';
  searchTo = '';
  filteredFromYears: number[] = [];
  filteredToYears: number[] = [];

  currentDecadeStart = 2010;
  decadeYears: number[] = [];

  categoryId!: string;
  categoryName = '';

  subcategories: any[] = [];
  randomEquipments: any[] = [];
  filteredRandom: any[] = [];

  equipmentList: any[] = [];
  filteredEquipment: any[] = [];

  openSectionStates: { [key: string]: boolean } = {};

  emirates: string[] = [
    'Dubai',
    'Sharjah',
    'Abu Dhabi',
    'Ajman',
    'Fujairah',
    'Umm Al Quwain',
  ];
  fuels: string[] = [];
  makes: string[] = [];
  allMakes: string[] = [];
  allFuels: string[] = [];
  years: number[] = [];
  origins: string[] = [];

  selectedFuels: string[] = [];
  selectedMakes: string[] = [];
  selectedYears: number[] = [];
  selectedOrigins: string[] = [];
  selectedSubcategories: string[] = [];
  pendingSubcategories: string[] = [];

  searchText = '';
  selectedEmirate = '';

  isLoading = false;
  displayedCount = 10;
  imagesLoadedCount = 0;
  totalImagesToWait = 0;

  onImageLoad() {
    this.imagesLoadedCount++;
  }

  private async waitForImages(targetCount: number, timeoutMs: number = 3000): Promise<void> {
    if (targetCount <= 0) return;
    return new Promise((resolve) => {
      const startTime = Date.now();
      const interval = setInterval(() => {
        const elapsed = Date.now() - startTime;
        if (this.imagesLoadedCount >= targetCount || elapsed >= timeoutMs) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }

  pendingFuels: string[] = [];
  pendingMakes: string[] = [];
  pendingYears: number[] = [];
  pendingOrigins: string[] = [];
  pendingEmirate = '';

  isFuelModalOpen = false;
  isMakeModalOpen = false;

  selectedWithDriver: boolean | null = null;
  selectedWithFuel: boolean | null = null;

  // COMPARISON SYSTEM
  isCompareMode: boolean = false;
  compareList: any[] = [];
  showCompareModal = false;
  bestValueRecommendation: {
    recommendedId: string;
    recommendedName: string;
    recommendedBrand: string;
    recommendedImg: string;
    recommendedRate: number;
    reasons: string[];
    keyDifferences: string[];
  } | null = null;
  get showRecommended(): boolean {
    return this.categoryId !== 'all';
  }

  get showCompare(): boolean {
    return this.categoryId !== 'all';
  }

  /** Returns true if a card should be disabled (limit reached and not already selected) */
  isCompareDisabled(eq: any): boolean {
    return this.isCompareMode && this.compareList.length >= 3 && !this.isInCompareList(eq);
  }

  getRatePeriod(equip: any): string {
    if (equip.hasDailyRate !== false && Number(equip.dailyRate) > 0) {
      return '/ day';
    } else if (equip.hasWeeklyRate !== false && Number(equip.weeklyRate) > 0) {
      return '/ week';
    } else if (equip.hasMonthlyRate !== false && Number(equip.monthlyRate) > 0) {
      return '/ month';
    } else if (equip.hasTripRate !== false && Number(equip.tripRate) > 0) {
      return '/ trip';
    } else if (equip.hasPerCubicMetreRate !== false && Number(equip.perCubicMetreRate) > 0) {
      return '/ cbm';
    }
    return '/ day';
  }

  getRatePrice(equip: any): number {
    if (equip.hasDailyRate !== false && Number(equip.dailyRate) > 0) {
      return equip.dailyRate;
    } else if (equip.hasWeeklyRate !== false && Number(equip.weeklyRate) > 0) {
      return equip.weeklyRate;
    } else if (equip.hasMonthlyRate !== false && Number(equip.monthlyRate) > 0) {
      return equip.monthlyRate;
    } else if (equip.hasTripRate !== false && Number(equip.tripRate) > 0) {
      return equip.tripRate;
    } else if (equip.hasPerCubicMetreRate !== false && Number(equip.perCubicMetreRate) > 0) {
      return equip.perCubicMetreRate;
    }
    return equip.dailyRate || 0;
  }

  getOptionCount(option: string, type: 'fuel' | 'make'): number {
    return this.equipmentList.filter(eq => {
      if (type === 'fuel') return eq.fuel_type === option;
      if (type === 'make') return eq.brand === option;
      return false;
    }).length;
  }

  openFilterModal(type: 'fuel' | 'make') {
    if (type === 'fuel') {
      this.isFuelModalOpen = true;
    } else {
      this.isMakeModalOpen = true;
    }
  }

  closeFilterModals() {
    this.isFuelModalOpen = false;
    this.isMakeModalOpen = false;
  }

  showCalendarFrom = false;
  showCalendarTo = false;

  searchStartDisplay: string | null = null;
  searchEndDisplay: string | null = null;
  searchStartDate: Date | null = null;
  searchEndDate: Date | null = null;

  pendingStartDisplay: string | null = null;
  pendingEndDisplay: string | null = null;
  pendingStartDate: Date | null = null;
  pendingEndDate: Date | null = null;

  currentDate: Date = new Date();
  currentMonth: number = this.currentDate.getMonth();
  currentYear: number = this.currentDate.getFullYear();

  weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  calendarDays: any[] = [];

  get currentMonthName(): string {
    return new Date(this.currentYear, this.currentMonth).toLocaleString(
      'default',
      { month: 'long' },
    );
  }

  constructor(
    private route: ActivatedRoute,
    private firestore: Firestore,
    private router: Router,
    private ux: UxserviceService,
    private lockService: BookingLockService,
    private location: Location,
    private dialog: MatDialog,
    private auth: Auth,
    private demoVendorService: DemoVendorService,
  ) { }

  @HostListener('document:click')
  closeCalendars() {
    this.showCalendarFrom = false;
    this.showCalendarTo = false;
    this.fromOpen = false;
    this.toOpen = false;
  }

  loadMore() {
    this.displayedCount += 10;
  }

  get hasMore(): boolean {
    return this.displayedCount < this.filteredEquipment.length;
  }

  getSubcategoryName(id: string): string {
    const sub = this.subcategories.find((s) => s.id === id);
    return sub ? sub.name : 'Unknown';
  }

  removeFilter(type: string, value?: any) {
    switch (type) {
      case 'text':
        this.searchText = '';
        break;
      case 'emirate':
        this.selectedEmirate = '';
        this.pendingEmirate = '';
        break;
      case 'fuel':
        this.selectedFuels = this.selectedFuels.filter((v) => v !== value);
        this.pendingFuels = [...this.selectedFuels];
        break;
      case 'make':
        this.selectedMakes = this.selectedMakes.filter((v) => v !== value);
        this.pendingMakes = [...this.selectedMakes];
        break;
      case 'year':
        this.selectedYears = this.selectedYears.filter((v) => v !== value);
        this.pendingYears = [...this.selectedYears];
        break;
      case 'subcategory':
        this.selectedSubcategories = this.selectedSubcategories.filter(
          (v) => v !== value,
        );
        this.pendingSubcategories = [...this.selectedSubcategories];
        break;
      case 'origin':
        this.selectedOrigins = this.selectedOrigins.filter((v) => v !== value);
        this.pendingOrigins = [...this.selectedOrigins];
        break;
      case 'date':
        this.searchStartDate = null;
        this.searchEndDate = null;
        this.searchStartDisplay = null;
        this.searchEndDisplay = null;
        this.pendingStartDate = null;
        this.pendingEndDate = null;
        this.pendingStartDisplay = null;
        this.pendingEndDisplay = null;
        break;
    }

    this.applyFilters();
    this.filterRandomByEmirate();

    const queryParams: any = {
      what: this.searchText || null,
      emirate: this.selectedEmirate || null,
      from: this.searchStartDisplay || null,
      to: this.searchEndDisplay || null,
    };

    const navigateTarget = type === 'text' ? ['/category', 'all'] : [];
    this.router.navigate(navigateTarget, {
      queryParams,
      queryParamsHandling: 'merge',
    });
  }

  goBack() {
    this.location.back();
  }

  getDateForDay(day: any): Date | null {
    if (!day || !day.date) return null;
    return new Date(this.currentYear, this.currentMonth, day.date);
  }

  isEndSelected(day: any): boolean {
    if (!day || !day.date || !this.pendingEndDisplay) return false;
    const d = this.getDateForDay(day);
    return this.pendingEndDisplay === this.formatDisplayDate(d!);
  }

  private parseDDMMYYYY(dateStr: string): Date | null {
    if (!dateStr) return null;
    const parts = dateStr.split('/');
    if (parts.length !== 3) return null;
    const day = Number(parts[0]);
    const month = Number(parts[1]) - 1;
    const year = Number(parts[2]);
    return new Date(year, month, day);
  }

  async ngOnInit() {
    combineLatest([this.route.params, this.route.queryParams]).subscribe(
      async ([params, queryParams]) => {
        this.isLoading = true;
        await this.ux.showOverlay('Loading equipments...');

        this.equipmentList = [];
        this.filteredEquipment = [];
        this.randomEquipments = [];
        this.filteredRandom = [];

        const newCategoryId = params['id'];
        const whatParam = queryParams['what'] || '';
        const emirateParam = queryParams['emirate'] || '';
        const fromParam = queryParams['from'] || '';
        const toParam = queryParams['to'] || '';
        const withDriverParam = queryParams['withDriver'];
        const withFuelParam = queryParams['withFuel'];

        if (withDriverParam === 'Yes' || withDriverParam === 'true') this.selectedWithDriver = true;
        else this.selectedWithDriver = null;

        if (withFuelParam === 'Yes' || withFuelParam === 'true') this.selectedWithFuel = true;
        else this.selectedWithFuel = null;
        const categoryChanged = this.categoryId !== newCategoryId;
        this.categoryId = newCategoryId;

        if (categoryChanged) {
          this.compareList = [];
          this.isCompareMode = false;
          this.showCompareModal = false;
          this.bestValueRecommendation = null;
        }

        this.searchText = whatParam;
        this.selectedEmirate = emirateParam;

        this.searchStartDate = this.parseDDMMYYYY(fromParam);
        this.searchEndDate = this.parseDDMMYYYY(toParam);

        this.searchStartDisplay = this.searchStartDate
          ? this.formatDisplayDate(this.searchStartDate)
          : null;
        this.searchEndDisplay = this.searchEndDate
          ? this.formatDisplayDate(this.searchEndDate)
          : null;

        this.pendingEmirate = this.selectedEmirate;
        this.pendingStartDate = this.searchStartDate;
        this.pendingEndDate = this.searchEndDate;
        this.pendingStartDisplay = this.searchStartDisplay;
        this.pendingEndDisplay = this.searchEndDisplay;

        if (!this.allYearsForDropdown.length) {
          this.setDecadeYears();
          this.generateYearDropdown();
        }

        try {
          const baseName = await this.loadCategoryData();
          await this.loadSubcategories();

          if (emirateParam) {
            await this.loadEquipmentByCategoryAndEmirate(this.categoryId, emirateParam);
            this.categoryName = `${baseName} in ${emirateParam}`;
          } else {
            await this.loadEquipmentByCategory(this.categoryId);
            this.categoryName = baseName;
          }

          if (this.randomEquipments.length === 0 || categoryChanged) {
            await this.loadRandomEquipments();
          }

          this.extractFilters();

          if (this.filteredFromYears.length === 0) {
            this.filteredFromYears = [...this.allYearsForDropdown];
            this.filteredToYears = [...this.allYearsForDropdown];
          }

          if (this.searchStartDate && this.searchEndDate) {
            await this.filterOutUnavailableEquipments();
          }

          this.applyFilters();

          this.pendingFuels = [...this.selectedFuels];
          this.pendingMakes = [...this.selectedMakes];
          this.pendingYears = [...this.selectedYears];
          this.pendingOrigins = [...this.selectedOrigins];
          this.pendingSubcategories = [...this.selectedSubcategories];
          this.pendingEmirate = this.selectedEmirate;
        } catch (error) {
          console.error('Error loading category page:', error);
          this.ux.showError('Failed to load equipments.');
        } finally {
          this.ux.closeOverlay();
          this.isLoading = false;
        }
      },
    );
  }

  setDecadeYears() {
    this.decadeYears = Array.from(
      { length: 10 },
      (_, i) => this.currentDecadeStart + i,
    ).filter((y) => this.years.includes(y));
  }

  changeDecade(direction: number) {
    this.currentDecadeStart += direction * 10;
    this.setDecadeYears();
  }

  generateYearDropdown() {
    const currentYear = new Date().getFullYear();
    this.allYearsForDropdown = [];
    for (let y = currentYear; y >= 1980; y--) {
      this.allYearsForDropdown.push(y);
    }
  }

  filterFromList() {
    this.filteredFromYears = this.allYearsForDropdown.filter((y) =>
      y.toString().includes(this.searchFrom),
    );
  }

  filterToList() {
    this.filteredToYears = this.allYearsForDropdown.filter((y) =>
      y.toString().includes(this.searchTo),
    );
  }

  selectFromYear(y: number) {
    this.yearFromInput = y;
    this.searchFrom = y.toString();
    this.fromOpen = false;
    this.validateYearInputs();
  }

  selectToYear(y: number) {
    this.yearToInput = y;
    this.searchTo = y.toString();
    this.toOpen = false;
    this.validateYearInputs();
  }

  validateYearInputs() {
    if (!this.yearFromInput || !this.yearToInput) {
      this.validYearRange = [];
      this.pendingYears = [];
      return;
    }

    const from = this.yearFromInput;
    const to = this.yearToInput;

    if (from > to) return;

    const generatedRange: number[] = [];
    for (let y = from; y <= to; y++) {
      generatedRange.push(y);
    }

    this.validYearRange = generatedRange.filter((y) => this.years.includes(y));
    this.pendingYears = [...this.validYearRange];
  }

  toggleYearChip(year: number) {
    if (this.pendingYears.includes(year)) {
      this.pendingYears = this.pendingYears.filter((y) => y !== year);
    } else {
      this.pendingYears.push(year);
    }
  }

  toggleAccordion(section: string) {
    Object.keys(this.openSectionStates).forEach((key) => {
      if (key !== section) this.openSectionStates[key] = false;
    });
    this.openSectionStates[section] = !this.openSectionStates[section];
  }

  async loadCategoryData(): Promise<string> {
    if (this.categoryId && this.categoryId.toString().toLowerCase() === 'all') {
      return 'All Equipments';
    }
    const catRef = collection(this.firestore, 'vehicle-categories');
    const snap = await getDocs(catRef);
    const categories = snap.docs.map((d) => ({ id: d.id, ...(d.data() as any) }));
    const selectedCat = categories.find((c) => c.id === this.categoryId);
    return selectedCat ? selectedCat.name : 'Category';
  }

  async loadSubcategories() {
    if (this.categoryId === 'all') {
      this.subcategories = [];
      return;
    }
    const subRef = collection(this.firestore, 'vehicle-subcategories');
    const qy = query(subRef, where('categoryId', '==', this.categoryId));
    const snap = await getDocs(qy);
    this.subcategories = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  }

  async loadEquipmentByCategory(categoryId: string) {
    const ref = collection(this.firestore, 'equipment-list');
    let qy;
    if (categoryId === 'all') {
      qy = query(ref, where('status', '==', 'Active'));
    } else {
      qy = query(ref, where('categoryId', '==', categoryId), where('status', '==', 'Active'));
    }

    const snap = await getDocs(qy);
    const now = new Date();
    const activeList = snap.docs
      .map((d) => ({ id: d.id, ...d.data() as any }))
      .filter((eq) => {
        return eq.isMarketplaceActive === true;
      });

    this.equipmentList = await this.attachRatings(activeList);
  }

  async loadEquipmentByCategoryAndEmirate(categoryId: string, emirate: string) {
    const ref = collection(this.firestore, 'equipment-list');
    let qy;
    if (categoryId === 'all') {
      qy = query(ref, where('emirate', '==', emirate), where('status', '==', 'Active'));
    } else {
      qy = query(
        ref,
        where('categoryId', '==', categoryId),
        where('emirate', '==', emirate),
        where('status', '==', 'Active'),
      );
    }

    const snap = await getDocs(qy);
    const now = new Date();
    const activeList = snap.docs
      .map((d) => ({ id: d.id, ...d.data() as any }))
      .filter((eq) => {
        return eq.isMarketplaceActive === true;
      });

    this.equipmentList = await this.attachRatings(activeList);
  }

  async loadRandomEquipments() {
    const ref = collection(this.firestore, 'equipment-list');
    const q = query(ref, where('status', '==', 'Active'));
    const snap = await getDocs(q);
    const now = new Date();
    const all = snap.docs
      .map((d) => ({ id: d.id, ...d.data() as any }))
      .filter((eq) => {
        return eq.isMarketplaceActive === true;
      });

    const withDemo = await this.demoVendorService.attachDemoFlags(all);
    this.allMakes = [...new Set(withDemo.map((eq: any) => eq.brand).filter(Boolean))];
    this.allFuels = [...new Set(withDemo.map((eq: any) => eq.fuel_type).filter(Boolean))];

    this.randomEquipments = withDemo.sort(() => 0.5 - Math.random()).slice(0, 6);
    this.filteredRandom = [...this.randomEquipments];
  }

  extractFilters() {
    const categoryFuels = [
      ...new Set(this.equipmentList.map((eq) => eq['fuel_type']).filter(Boolean)),
    ].sort();
    const categoryMakes = [
      ...new Set(this.equipmentList.map((eq) => eq['brand']).filter(Boolean)),
    ].sort();

    const otherFuels = this.allFuels.filter(f => !categoryFuels.includes(f)).sort();
    const otherMakes = this.allMakes.filter(m => !categoryMakes.includes(m)).sort();

    this.fuels = [...categoryFuels, ...otherFuels];
    this.makes = [...categoryMakes, ...otherMakes];

    this.years = [
      ...new Set(
        this.equipmentList
          .map((eq) => Number(eq['year_of_manufacture']))
          .filter((y) => !isNaN(y)),
      ),
    ];

    this.origins = [
      ...new Set(this.equipmentList.map((eq) => eq['origin']).filter(Boolean)),
    ];
  }

  applyFilters() {
    const isSearchMatchingCategory =
      this.categoryName &&
      this.searchText &&
      this.categoryName.toLowerCase().includes(this.searchText.toLowerCase());

    this.filteredEquipment = this.equipmentList.filter((eq) => {
      const matchSearch =
        !this.searchText ||
        isSearchMatchingCategory ||
        eq.name?.toLowerCase().includes(this.searchText.toLowerCase());

      const matchEmirate =
        !this.selectedEmirate || eq.emirate === this.selectedEmirate;

      const matchSubcat =
        !this.selectedSubcategories.length ||
        this.selectedSubcategories.includes(eq.subcategoryId);

      const matchFuel =
        !this.selectedFuels.length || this.selectedFuels.includes(eq.fuel_type);

      const matchMake =
        !this.selectedMakes.length || this.selectedMakes.includes(eq.brand);

      const matchYear =
        !this.selectedYears.length ||
        this.selectedYears.includes(Number(eq.year_of_manufacture));

      const matchWithDriver = this.selectedWithDriver === null ||
        (this.selectedWithDriver === true ? eq.withDriver === 'Yes' : eq.withDriver === 'No');

      const matchWithFuel = this.selectedWithFuel === null ||
        (this.selectedWithFuel === true ? eq.withFuel === 'Yes' : eq.withFuel === 'No');

      return (
        matchSearch &&
        matchEmirate &&
        matchSubcat &&
        matchFuel &&
        matchMake &&
        matchYear &&
        matchWithDriver &&
        matchWithFuel
      );
    });
    this.displayedCount = 10;
  }

  toggleSelection(item: string | number, type: 'fuel' | 'make' | 'year' | 'origin') {
    const map: { [key: string]: any[] } = {
      fuel: this.pendingFuels,
      make: this.pendingMakes,
      year: this.pendingYears,
      origin: this.pendingOrigins,
    };

    const list = map[type];
    const idx = list.indexOf(item);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(item);
    }
  }

  onEmirateChange() {
    this.pendingEmirate = this.selectedEmirate;
  }

  clearAllFilters() {
    this.searchStartDate = null;
    this.searchEndDate = null;
    this.searchStartDisplay = null;
    this.searchEndDisplay = null;
    this.pendingStartDate = null;
    this.pendingEndDate = null;
    this.pendingStartDisplay = null;
    this.pendingEndDisplay = null;
    this.showCalendarFrom = false;
    this.showCalendarTo = false;

    this.yearFromInput = null;
    this.yearToInput = null;
    this.searchFrom = '';
    this.searchTo = '';
    this.fromOpen = false;
    this.toOpen = false;
    this.validYearRange = [];
    this.pendingYears = [];
    this.selectedYears = [];
    this.filteredFromYears = [...this.allYearsForDropdown];
    this.filteredToYears = [...this.allYearsForDropdown];

    this.searchText = '';
    this.selectedEmirate = '';
    this.selectedSubcategories = [];
    this.selectedFuels = [];
    this.selectedMakes = [];
    this.selectedOrigins = [];

    this.pendingEmirate = '';
    this.pendingSubcategories = [];
    this.pendingFuels = [];
    this.pendingMakes = [];
    this.pendingOrigins = [];
    this.pendingYears = [];

    this.filteredEquipment = [...this.equipmentList];
    this.displayedCount = 10;

    this.router.navigate(['/category', 'all'], {
      queryParams: { what: null, emirate: null, from: null, to: null },
      queryParamsHandling: 'merge',
    });
  }

  private async filterOutUnavailableEquipments() {
    try {
      const bookingRef = collection(this.firestore, 'booking-list');
      const snap = await getDocs(bookingRef);
      const allBookings = snap.docs.map((d) => ({ id: d.id, ...(d.data() as any) }));

      const unavailableIds = new Set<string>();

      const sStart = new Date(this.searchStartDate!);
      sStart.setHours(0, 0, 0, 0);
      const sEnd = new Date(this.searchEndDate!);
      sEnd.setHours(23, 59, 59, 999);

      allBookings
        .filter((b: any) => b.status === 'Confirmed')
        .forEach((b: any) => {
          try {
            if (!b.customer || !b.customer.startDate || !b.customer.endDate) return;

            const parseDate = (d: any) => {
              if (d && typeof d.toDate === 'function') return d.toDate();
              else if (d instanceof Date) return d;
              else return new Date(d);
            };

            const bStart = parseDate(b.customer.startDate);
            const bEnd = parseDate(b.customer.endDate);

            if (isNaN(bStart.getTime()) || isNaN(bEnd.getTime())) return;

            if (bStart <= sEnd && bEnd >= sStart) {
              unavailableIds.add(b.equipmentId);
            }
          } catch (err) {
            console.error('Error checking booking', b.id, err);
          }
        });

      const checkLocksPromises = this.equipmentList.map(async (eq) => {
        if (unavailableIds.has(eq.id)) return;
        try {
          const locks = await this.lockService.getLockedDates(eq.id);
          const sStartTs = sStart.getTime();
          const sEndTs = sEnd.getTime();
          const isLocked = locks.some((lock) => lock.start <= sEndTs && lock.end >= sStartTs);
          if (isLocked) unavailableIds.add(eq.id);
        } catch (err) {
          console.error('Error checking lock for equipment', eq.id, err);
        }
      });

      await Promise.all(checkLocksPromises);

      this.equipmentList = this.equipmentList.filter((eq) => !unavailableIds.has(eq.id));
      this.filteredRandom = this.filteredRandom.filter((eq) => !unavailableIds.has(eq.id));
    } catch (error) {
      console.error('CRITICAL: Error in filterOutUnavailableEquipments', error);
      throw error;
    }
  }

  filterRandomByEmirate() {
    if (!this.selectedEmirate) {
      this.filteredRandom = this.randomEquipments;
      return;
    }
    this.filteredRandom = this.randomEquipments.filter(
      (eq) => eq.emirate === this.selectedEmirate,
    );
  }

  async attachRatings(list: any[]): Promise<any[]> {
    const withRatings: any[] = [];
    const needsFetch: any[] = [];

    for (const eq of list) {
      if (eq.avgRating !== undefined && eq.totalReviews !== undefined) {
        withRatings.push(eq);
      } else {
        needsFetch.push(eq);
      }
    }

    const fetched = await Promise.all(
      needsFetch.map(async (eq) => {
        try {
          const revRef = collection(this.firestore, `reviews/${eq.id}/items`);
          const snap = await getDocs(revRef);
          let total = 0;
          let count = 0;
          snap.forEach((r) => {
            const data: any = r.data();
            if (data.rating) { total += data.rating; count++; }
          });
          return { ...eq, avgRating: count > 0 ? Number((total / count).toFixed(1)) : 0, totalReviews: count };
        } catch {
          return { ...eq, avgRating: 0, totalReviews: 0 };
        }
      })
    );

    const merged = [...withRatings, ...fetched];
    return await this.demoVendorService.attachDemoFlags(merged);
  }

  async onDateRangeChange() {
    if (!this.searchStartDate || !this.searchEndDate) return;
    await this.filterOutUnavailableEquipments();
    this.applyFilters();
  }

  generateCalendar() {
    const days: any[] = [];
    const firstDay = new Date(this.currentYear, this.currentMonth, 1).getDay();
    const lastDate = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    for (let i = 0; i < firstDay; i++) {
      days.push({ date: '', inactive: true, isToday: false, isPast: false });
    }

    for (let d = 1; d <= lastDate; d++) {
      const thisDate = new Date(this.currentYear, this.currentMonth, d);
      thisDate.setHours(0, 0, 0, 0);
      days.push({
        date: d,
        inactive: false,
        isToday: thisDate.getTime() === today.getTime(),
        isPast: thisDate < today,
      });
    }

    this.calendarDays = days;
  }

  prevMonth() {
    this.currentMonth--;
    if (this.currentMonth < 0) { this.currentMonth = 11; this.currentYear--; }
    this.generateCalendar();
  }

  nextMonth() {
    this.currentMonth++;
    if (this.currentMonth > 11) { this.currentMonth = 0; this.currentYear++; }
    this.generateCalendar();
  }

  openFromCalendar(event: Event) {
    this.showCalendarFrom = true;
    this.showCalendarTo = false;
    this.generateCalendar();
    event.stopPropagation();
  }

  openToCalendar(event: Event) {
    this.showCalendarTo = true;
    this.showCalendarFrom = false;
    this.generateCalendar();
    event.stopPropagation();
  }

  private formatDisplayDate(date: Date): string {
    const d = date.getDate().toString().padStart(2, '0');
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const y = date.getFullYear();
    return `${d}/${m}/${y}`;
  }

  selectStartDay(day: any) {
    if (day.inactive || !day.date) return;
    const selected = new Date(this.currentYear, this.currentMonth, day.date);
    this.pendingStartDate = selected;
    this.pendingStartDisplay = this.formatDisplayDate(selected);
    this.pendingEndDate = null;
    this.pendingEndDisplay = null;
    this.showCalendarFrom = false;
  }

  selectEndDay(day: any) {
    if (day.inactive || !day.date) return;
    const selected = new Date(this.currentYear, this.currentMonth, day.date);
    this.pendingEndDate = selected;
    this.pendingEndDisplay = this.formatDisplayDate(selected);
    this.showCalendarTo = false;
  }

  mobileFilterOpen = false;

  getActiveFilterCount(): number {
    let count = 0;
    if (this.selectedEmirate) count++;
    if (this.selectedFuels && this.selectedFuels.length) count += this.selectedFuels.length;
    if (this.selectedMakes && this.selectedMakes.length) count += this.selectedMakes.length;
    if (this.selectedYears && this.selectedYears.length) count += this.selectedYears.length;
    if (this.selectedSubcategories && this.selectedSubcategories.length) count += this.selectedSubcategories.length;
    if (this.searchStartDisplay && this.searchEndDisplay) count++;
    return count;
  }

  async updateFilters() {
    this.mobileFilterOpen = false;
    this.selectedFuels = [...this.pendingFuels];
    this.selectedMakes = [...this.pendingMakes];
    this.selectedYears = [...this.pendingYears];
    this.selectedOrigins = [...this.pendingOrigins];
    this.selectedSubcategories = [...this.pendingSubcategories];
    this.selectedEmirate = this.pendingEmirate;

    this.searchStartDate = this.pendingStartDate;
    this.searchEndDate = this.pendingEndDate;
    this.searchStartDisplay = this.pendingStartDisplay;
    this.searchEndDisplay = this.pendingEndDisplay;
    this.selectedYears = [...this.pendingYears];

    if (this.searchStartDate && this.searchEndDate) {
      await this.filterOutUnavailableEquipments();
    }

    this.applyFilters();
    this.filterRandomByEmirate();

    const queryParams: any = { what: this.searchText || '', emirate: this.selectedEmirate || '' };

    if (this.searchStartDate) {
      queryParams['from'] = this.formatDisplayDate(this.searchStartDate);
    } else {
      queryParams['from'] = null;
    }

    if (this.searchEndDate) {
      queryParams['to'] = this.formatDisplayDate(this.searchEndDate);
    } else {
      queryParams['to'] = null;
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: 'merge',
    });
  }

  toggleSubcategory(id: string) {
    const idx = this.selectedSubcategories.indexOf(id);
    if (idx > -1) {
      this.selectedSubcategories.splice(idx, 1);
    } else {
      this.selectedSubcategories.push(id);
    }
    this.pendingSubcategories = [...this.selectedSubcategories];
    this.applyFilters();
  }

  viewDetails(eq: any) {
    this.router.navigate(['/auth/booking-detail', eq.id]);
  }

  ngAfterViewInit() {
    if (this.subcategories.length > 5) {
      this.updateThumbWidth();
      this.syncScrollBar(this.scrollArea.nativeElement);
    }
  }

  updateThumbWidth() {
    const area = this.scrollArea.nativeElement;
    const bar = this.scrollBarWrapper.nativeElement;
    const visibleRatio = area.clientWidth / area.scrollWidth;
    const thumbWidth = Math.max(40, bar.clientWidth * visibleRatio);
    this.scrollThumb.nativeElement.style.width = thumbWidth + 'px';
  }

  syncScrollBar(area: HTMLElement) {
    if (!this.scrollBarWrapper) return;
    const bar = this.scrollBarWrapper.nativeElement;
    const thumb = this.scrollThumb.nativeElement;
    const scrollRatio = area.scrollLeft / (area.scrollWidth - area.clientWidth);
    const maxThumbLeft = bar.clientWidth - thumb.clientWidth;
    thumb.style.left = maxThumbLeft * scrollRatio + 'px';
  }

  startDrag(event: MouseEvent, area: HTMLElement, bar: HTMLElement) {
    this.dragging = true;
    this.startX = event.clientX;
    this.startScrollLeft = area.scrollLeft;

    const mouseMove = (e: MouseEvent) => {
      if (!this.dragging) return;
      const barWidth = bar.clientWidth - this.scrollThumb.nativeElement.clientWidth;
      const deltaX = e.clientX - this.startX;
      const scrollAmount = deltaX * (area.scrollWidth / barWidth);
      area.scrollLeft = this.startScrollLeft + scrollAmount;
      this.syncScrollBar(area);
    };

    const mouseUp = () => {
      this.dragging = false;
      window.removeEventListener('mousemove', mouseMove);
      window.removeEventListener('mouseup', mouseUp);
    };

    window.addEventListener('mousemove', mouseMove);
    window.addEventListener('mouseup', mouseUp);
  }

  openServiceOfferDialog() {
    this.router.navigate(['/register-business']);
  }

  // ==========================
  // COMPARISON LOGIC
  // ==========================

  isInCompareList(eq: any): boolean {
    return this.compareList.some((item) => item.id === eq.id);
  }

  /**
   * Toggle compare selection.
   * - Max 3 items enforced: shows toast and returns early if limit would be exceeded.
   * - Removed items always work.
   */
  toggleCompare(event: Event, eq: any) {
    event.stopPropagation();
    const index = this.compareList.findIndex((item) => item.id === eq.id);

    if (index > -1) {
      // Always allow deselection
      this.compareList.splice(index, 1);
    } else {
      // Enforce max 3
      if (this.compareList.length >= 3) {
        this.ux.showError('Maximum 3 equipments can be compared.');
        return;
      }
      this.compareList.push(eq);
    }

    if (this.compareList.length < 2 && this.showCompareModal) {
      this.closeCompareModal();
    }
  }

  clearCompare() {
    this.compareList = [];
    this.closeCompareModal();
  }

  exitCompareMode() {
    this.isCompareMode = false;
    this.compareList = [];
    this.closeCompareModal();
  }

  openCompareModal() {
    if (this.compareList.length < 2) return;
    this.generateRecommendation();
    this.showCompareModal = true;
  }

  closeCompareModal() {
    this.showCompareModal = false;
  }

  generateRecommendation() {
    if (this.compareList.length === 0) {
      this.bestValueRecommendation = null;
      return;
    }

    let bestScore = -9999;
    let bestId = '';
    let bestReasons: string[] = [];

    let lowestMonthlyRate = Infinity;
    let highestRating = -1;

    this.compareList.forEach((eq) => {
      const rate = Number(eq.monthlyRate || eq.dailyRate * 20 || 999999);
      if (rate < lowestMonthlyRate) lowestMonthlyRate = rate;
      const rating = Number(eq.avgRating || 0);
      if (rating > highestRating) highestRating = rating;
    });

    this.compareList.forEach((eq) => {
      let score = 0;
      const reasons: string[] = [];
      const rate = Number(eq.monthlyRate || eq.dailyRate * 20 || 999999);
      const rating = Number(eq.avgRating || 0);

      if (rate <= lowestMonthlyRate && rate !== 999999) {
        score += 10;
        reasons.push('Lowest overall rental cost');
      }

      if (rating >= highestRating && rating > 0) {
        score += 5;
        reasons.push('Highest rating among compared equipment');
      }

      if (eq.withDriver === 'Yes' || eq.withDriver === true) {
        score += 3;
        reasons.push('Includes operator');
      }

      if (eq.withFuel === 'Yes' || eq.withFuel === true) {
        score += 2;
        reasons.push('Includes fuel');
      }

      if (reasons.length === 0) {
        reasons.push('Suitable for general projects');
      }

      reasons.push('Available immediately');

      if (score > bestScore) {
        bestScore = score;
        bestId = eq.id;
        bestReasons = reasons;
      }
    });

    const recommendedEq = this.compareList.find(eq => eq.id === bestId);

    const differences: string[] = [];

    const validRates = this.compareList
      .map(eq => ({ id: eq.id, name: eq.name, rate: Number(eq.monthlyRate || eq.dailyRate * 20 || 0) }))
      .filter(x => x.rate > 0);
    if (validRates.length >= 2) {
      validRates.sort((a, b) => a.rate - b.rate);
      const cheapest = validRates[0];
      const priciest = validRates[validRates.length - 1];
      if (priciest.rate > cheapest.rate) {
        const pct = Math.round(((priciest.rate - cheapest.rate) / priciest.rate) * 100);
        if (pct > 0) differences.push(`${cheapest.name} is ${pct}% cheaper monthly`);
      }
    }

    const validYears = this.compareList
      .map(eq => ({ id: eq.id, name: eq.name, year: Number(eq.year_of_manufacture || eq.year || 0) }))
      .filter(x => x.year > 0);
    if (validYears.length >= 2) {
      validYears.sort((a, b) => b.year - a.year);
      const newest = validYears[0];
      const oldest = validYears[validYears.length - 1];
      if (newest.year > oldest.year) differences.push(`${newest.name} is newer (${newest.year})`);
    }

    const emirates = this.compareList.map(eq => eq.emirate).filter(Boolean);
    if (emirates.length > 0) {
      const allSame = emirates.every(e => e === emirates[0]);
      if (allSame) {
        differences.push(`Both are available in ${emirates[0]}`);
      } else {
        const locStrings = this.compareList.map(eq => `${eq.name} is in ${eq.emirate || 'unknown'}`);
        differences.push(locStrings.join(', '));
      }
    }

    const withDriverItems = this.compareList.filter(eq => eq.withDriver === 'Yes' || eq.withDriver === true);
    if (withDriverItems.length === this.compareList.length) {
      differences.push('All compared equipment include operator');
    } else if (withDriverItems.length > 0) {
      differences.push(`${withDriverItems.map(x => x.name).join(' and ')} include${withDriverItems.length > 1 ? '' : 's'} operator`);
    }

    this.bestValueRecommendation = {
      recommendedId: bestId,
      recommendedName: recommendedEq?.name || 'Equipment',
      recommendedBrand: recommendedEq?.brand || 'Brand',
      recommendedImg: recommendedEq?.images?.[0] || 'assets/no-image-available.jpg',
      recommendedRate: recommendedEq?.dailyRate || 0,
      reasons: bestReasons,
      keyDifferences: differences,
    };
  }

  getLowestValueInRow(field: string): number {
    const vals = this.compareList.map(eq => Number(eq[field] || 0)).filter(v => v > 0);
    return vals.length > 0 ? Math.min(...vals) : 0;
  }

  getHighestValueInRow(field: string): number {
    const vals = this.compareList
      .map(eq => {
        if (field === 'year') return Number(eq.year_of_manufacture || eq.year || 0);
        return Number(eq[field] || 0);
      })
      .filter(v => v > 0);
    return vals.length > 0 ? Math.max(...vals) : 0;
  }

  getYearVal(eq: any): number {
    return Number(eq.year_of_manufacture || eq.year || 0);
  }
}